import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 静态引入语言包（Vue 2 不支持动态 import，改用 require）
const messages = {
    en: require('./locales/en.js').default,
    zh: require('./locales/zh.js').default,
}

// 创建 i18n 实例
const i18n = new VueI18n({
    locale: 'zh',         // 默认语言
    fallbackLocale: 'zh', // 回退语言
    silentTranslationWarn: true, // 生产环境禁止警告
    messages,            // 语言包
})

// 封装切换语言方法
function setLocale(lang) {
    if (i18n.locale !== lang && messages[lang]) {
        i18n.locale = lang
        localStorage.setItem('userLanguage', lang)
        document.documentElement.setAttribute('lang', lang)
    }
    return lang
}

// 初始化时读取缓存或浏览器语言
const savedLang = localStorage.getItem('userLanguage') ||
    navigator.language.split('-')[0]
setLocale(messages[savedLang] ? savedLang : 'en')

export { i18n, setLocale }
export default i18n